var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHatchback = function SvgHatchback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 68 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.77 11.561C9.294 12.496 3.142 19.738 1 23.243v8.429a3 3 0 0 0 1.2 2.4l.336.252a3 3 0 0 0 1.8.6h59.89c1.003 0 1.966-.488 2.424-1.38.2-.39.35-.752.35-.956v-5.84c0-1.753-2.675-4.007-4.673-4.673-3.032-1.011-8.544-1.73-12.749-2.158A7.15 7.15 0 0 1 46.2 18.67l-7.679-5.375c-1.626-1.138-3.505-1.867-5.485-2.006-4.13-.289-10.5-.448-16.266.272Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0BDF4",
    d: "M43.055 20.323H27.87l-16.354-1.169c.584-1.168 5.54-4.034 8.177-4.672 3.99-.442 10.289-.11 14.28.331.585.12 1.151.323 1.68.601 1.86 1.066 5.666 3.653 7.402 4.909"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M33.12 20.906c11.098.195 11.428.33 11.098 0-1.104-1.104-4.816-3.25-9.164-5.455a4.8 4.8 0 0 0-1.615-.489c-4.575-.546-10.456-1.03-13.752-.48-2.229.371-5.446 2.037-7.609 3.274-.806.462-.554 1.634.367 1.757l6.074.81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M25.531 14.482v5.84"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.151,
    cy: 32.588,
    r: 5.675,
    fill: "#fff",
    stroke: "#36354C",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.268,
    cy: 32.588,
    r: 5.675,
    fill: "#fff",
    stroke: "#36354C",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M56.485 32.588a2.336 2.336 0 1 1-4.673 0 2.336 2.336 0 0 1 4.673 0M15.602 32.588a2.336 2.336 0 1 1-4.672 0 2.336 2.336 0 0 1 4.672 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#36354C",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M23.781 20.907h4.089"
  })));
};
export default SvgHatchback;